import type { MarketVariants } from '@/lib/i18n'

export type Slide1TitleCopy = {
  eyebrow: string
  title: string
  subtitle: string
  hintDesktop: string
  hintMobile: string
}

export const copy: MarketVariants<Slide1TitleCopy> = {
  US: {
    eyebrow: 'Chapter 4',
    title: 'Spot the Warning Signs',
    subtitle: 'Five scam signals you should never ignore.',
    hintDesktop: 'Tip: Arrow keys also work',
    hintMobile: 'Swipe or tap Next',
  },
  ar: {
    eyebrow: 'الفصل 4',
    title: 'علامات التحذير',
    subtitle: 'خمس إشارات احتيال لا ينبغي تجاهلها أبداً.',
    hintDesktop: 'نصيحة: يمكنك أيضاً استخدام مفاتيح الأسهم',
    hintMobile: 'اسحب أو اضغط "التالي"',
  },
}
